import { debounce } from './throttle-debounce';
import scss from 'scss';

export default class Accordion {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $body: $('body')
        };

        if (this.dom.$body.find('.accordion-trigger').length) {
            this.init();
        }
    }

    init() {
        this.eventTrigger();
        this.eventOnResize();
        this.openOnInit();

        //Handle header menu mobile touch effect
        if ('ontouchstart' in document.documentElement) {
            $('body').on('click', '.dropdown-toggle', function (e) {
                if (!$(e.target).parent().hasClass('open')) {
                    $(e.target).parent().addClass('open');
                    e.preventDefault;
                    return false;
                }
            });
            $('body').on('click', function (e) {
                if (!($(e.target).is("a[href]") || $(e.target).hasClass('.dropdown') && $(e.target).hasClass('.open'))) {
                    $('.dropdown.open').removeClass('open');
                }
            });
        }
    }

    openOnInit() {
        this.dom.$body.find('.accordion-trigger').each((_, target) => {
            let $trigger = $(target);
            let targetClass = $trigger.attr('data-target');
            if (targetClass != undefined) {
                let $target = $(targetClass);
                $trigger.attr({ 'role': 'button', 'aria-controls': targetClass.substring(1), 'tabindex': '0' });
                $target.attr('role', 'region');
                $target.first().attr('id', $trigger.attr('aria-controls'));
                if ($target.attr('aria-labelledby') == undefined) {
                    let $headers = $trigger.find('h1, h2, h3');
                    if ($headers.length > 0) {
                        $trigger.attr('id', targetClass.substring(1) + '-title');
                        $target.attr('aria-labelledby', targetClass.substring(1) + '-title');
                    }
                }
            }
            $trigger.attr('aria-expanded', $trigger.hasClass('accordion-open') ? 'true' : 'false');

            if ($trigger.data('open') !== undefined && $trigger.data('close') !== undefined && $trigger.find('p,span').length > 0) {
                $trigger.find('p,span').text($trigger.hasClass('accordion-open') ? $trigger.data('close') : $trigger.data('open'));
            }
        });
    }

    toggleAccordion($accordions, displayType) {
        if (!$accordions.length) {
            return;
        }

        $accordions.each((_, target) => {
            if ($(target).is(':visible')) {
                if (displayType == 'flex') {
                    $(target).children().slideUp('slow', function () {
                        $(target).hide();
                    });
                    ;
                } else {
                    $(target).slideUp('slow');
                }
            } else {
                if (displayType == 'flex') {
                    $(target).css('display', 'flex');
                    $(target).children().slideDown('slow');
                } else {
                    $(target).slideDown('slow');
                }
            }
        });
    }

    onResizeCallback() {
        let $footerAccordion = $('.footer-nav-header');

        $footerAccordion
            .toggleClass('accordion-disabled', $footerAccordion.length && this.dom.$window.width() >= parseInt(scss['$md']));
    }

    eventTrigger() {
        this.dom.$body.off('keydown', '.accordion-trigger').on('keydown', '.accordion-trigger', (e) => {
            let $trigger = $(e.currentTarget);
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $trigger.click();
            }
        });

        this.dom.$body.off('click', '.accordion-trigger').on('click', '.accordion-trigger', (e) => {
            let $trigger = $(e.currentTarget);
            let $target;
            let displayType;

            if (!$trigger.is('input')) {
                e.preventDefault();
            }

            if ($trigger.hasClass('accordion-disabled')) {
                return;
            }

            $('.content-popup.visible').remove();

            if ($trigger.attr('data-target') !== undefined) {
                $target = this.dom.$body.find($trigger.attr('data-target'));
            } else {
                $target = $trigger.parent().find('.accordion-content');
            }

            $trigger.toggleClass('accordion-open').attr('aria-expanded', $trigger.hasClass('accordion-open') ? 'true' : 'false');

            //Change "open"/"close" text accordingly
            if ($trigger.attr('data-open') !== undefined && $trigger.attr('data-close') !== undefined && $trigger.find('p,span').length > 0) {
                $trigger.find('p,span').text($trigger.hasClass('accordion-open') ? $trigger.attr('data-close') : $trigger.attr('data-open'));
            }

            if ($trigger.attr('data-display') !== undefined && $trigger.attr('data-display') != "") {
                displayType = $trigger.attr('data-display');
            } else {
                displayType = "block";
            }
            this.toggleAccordion($target, displayType);
        });
    }

    eventOnResize() {
        this.onResizeCallback();
        this.dom.$window.on('resize', debounce(200, this.onResizeCallback.bind(this)));
    }
}
